export const injectSquashServiceAndSport = (arr) => arr?.map(m => {
  // m.sport = {id: 7}
  // m.service = {id: 10}
  m.sport_id = 7;
  m.services = [10];
  return m;
})